<template>
  <v-container fluid grid-list-md py1>
    <v-layout row wrap>
      <v-flex md4>
        <v-card>
          <v-card-title primary-title class="py-2">
            <v-toolbar-title>{{ $t("view.operativos.popEntryExit.title") }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <v-flex v-show="view.elem.showForm" class="py-0">
              <v-card-text>
                <form onSubmit="return false;" @submit="submit" @keyup.ctrl.83="executeValidators">
                  <!-- Clave -->
                  <v-text-field v-if="popEntryExit.clave" v-model="popEntryExit.clave" :label="$t('view.commons.clave')" disabled />

                  <!-- Descripcion -->
                  <v-text-field
                    v-model.trim="$v.popEntryExit.descripcion.$model"
                    :label="$t('view.operativos.popEntryExit.form.descripcion.label')"
                    :error-messages="getFirstErrorDescription($v.popEntryExit.descripcion)"
                    maxlength="255"
                    :disabled="view.action.submit.busy"
                    onkeypress="return /^[a-zA-Z0-9\r\.\+\-\_\ ]+$/.test(event.key);" />

                  <!-- Tipo -->
                  <v-flex md12>
                    <v-autocomplete
                      v-model.trim="$v.popEntryExit.tipo.$model"
                      :label="$t('view.operativos.popEntryExit.form.tipo.label')"
                      :error-messages="getFirstErrorDescription($v.popEntryExit.tipo)"
                      :items="view.elem.select.tipo.filteredList"
                      :disabled="view.action.submit.busy || view.elem.select.tipo.disabled"
                      item-value="code"
                      item-text="name"
                      hide-selected
                      deletable-chips
                      clearable
                      multiple
                      small-chips
                      :no-data-text="$t('view.commons.nodata')"
                      @input="search = ''" />
                  </v-flex>

                  <!-- Valor Default -->
                  <v-flex v-if="popEntryExit.tipo.includes(TIPO_POP_NUM_ENTRY)" md12>
                    <v-autocomplete
                      v-model.trim="$v.popEntryExit.defaults.$model"
                      :label="$t('view.operativos.popEntryExit.form.defaults.label')"
                      :error-messages="getFirstErrorDescription($v.popEntryExit.defaults)"
                      :items="popEntryExit.descripcion.includes('NO') ? view.elem.select.defaults.filteredList : view.elem.select.defaults.filteredListAlt"
                      :disabled="view.action.submit.busy || view.elem.select.defaults.disabled"
                      item-value="name"
                      item-text="name"
                      hide-selected
                      clearable
                      :no-data-text="$t('view.commons.nodata')"
                      @input="search = ''" />
                  </v-flex>

                  <!-- Multiple -->
                  <label for="multiple" class="v-label mt-3">{{ $t("view.operativos.popEntryExit.form.multiple.label") }}</label>
                  <v-switch v-model="popEntryExit.multiple" input-value="true" color="primary" :disabled="view.action.submit.busy" />

                  <!-- Estatus -->
                  <label for="status" class="v-label mt-3">{{ $t("view.commons.status") }}</label>
                  <v-switch v-model="popEntryExit.status" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                </form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-flex shrink>
                  <v-btn
                    v-show="popEntryExit.clave && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
                    id="btnaudit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="$t('view.commons.audit')"
                    :loading="view.action.submit.busy"
                    @click="audit()">
                    <v-icon small>storage</v-icon>
                  </v-btn>

                  <v-btn id="btnclear" fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.cancel')" :loading="view.action.submit.busy" @click="clear()">
                    <v-icon small>fa-eraser</v-icon>
                  </v-btn>

                  <v-btn
                    v-show="$userPermission.hasPermission('ROLE_MODIFICAR_OP')"
                    id="btnsubmit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="view.elem.button.submit.title.current"
                    :loading="view.action.submit.busy"
                    :disabled="form.$state.isDisableButtonSubmit()"
                    @click="submit()">
                    <v-icon small>{{ view.elem.button.submit.class.current }}</v-icon>
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-flex>
          </v-expand-transition>
        </v-card>
      </v-flex>

      <v-flex md8>
        <data-table ref="popEntryExitTable" @editRow="load" @auditRow="audit" />
      </v-flex>
    </v-layout>
    <auditoria ref="auditModal" />
  </v-container>
</template>
<script>
import popEntryExitStates from "@/views/operativos/popEntryExit/popEntryExit-state"; /** *******************************/
import popEntryExitAPI from "@/services/operativos/popEntryExit"; /** *******************************/
import DataTable from "@/views/operativos/popEntryExit/DataTable"; /** *******************************/
import Auditoria from "@/components/auditoria/Auditoria"; /** *******************************/
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { required } from "vuelidate/lib/validators";
import { fixMigImp } from "@/helpers/vuelidate/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { handleResponse } from "@/helpers/http-response-handler";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { TIPO_POP_SELECT, TIPO_POP_NUM_ENTRY } from "@/constants/operativos";
import { submit } from "@/constants/buttons";
import tippy from "tippy.js";

const select = {
  tipo: {
    filteredList: TIPO_POP_SELECT
    , disabled: false
  }
  , defaults: {
    completeList: []
    , filteredList: []
    , filteredListAlt: []
    , disabled: false
  }
};

const action = { submit: { busy: false } };

export default {
  name: "PopEntryExitModule"
  , components: {
    DataTable
    , Auditoria
  }
  , data() {
    return {
      popEntryExit: undefined
      , TIPO_POP_NUM_ENTRY
      , form: new Object()
      , view: {
        title: this.$t("view.operativos.popEntryExit.title")
        , action
        , elem: {
          button: { submit }
          , select
          , showForm: true
        }
      }
      , check: true
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , created() {
    this.form = new popEntryExitStates(this);
    this.form.$setState("initial");
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async submit() {
      try {
        const respuesta = await this.form.$state.submit(this.popEntryExit);
        handleResponse(respuesta, this.$t("view.operativos.popEntryExit.errors"));
      } catch (error) {
        handleResponse(error, this.$t("view.operativos.popEntryExit.errors"));
      }
    }
    , async load(clave) {
      try {
        const response = await popEntryExitAPI.get(clave);
        const { data: { results: { popEntryExit } } } = response;
        this.form.$setState("editing", popEntryExit);
      } catch (error) {
        console.log(error);
      }
    }
    , async clear() {
      await this.form.$state.askForClear();
      setTimeout(() => document.body.click(), 300);
    }
    , async audit(clave = this.popEntryExit.clave, dataDescripcion = this.popEntryExit.descripcion) {
      this.$refs.auditModal.loadAudit(clave, "TPopEntryExit", dataDescripcion, this.view.title);
    }
    , executeValidators() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
        scrollToForm(this);
      }
    }
  }
  , validations: {
    popEntryExit: {
      descripcion: { required, fixMigImp: fixMigImp() }
      , tipo: { required }
      , defaults: {}
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/operativos/popEntryExit/PopEntryExit.vue